import { Injectable } from '@angular/core';
import { ApiGateway } from '@app/api/ApiGateway.service';

@Injectable()
export class OnboardingPayrollService {
  public constructor(private api: ApiGateway) {}

  public savePreferredPayrollIntegration(preferredPayrollIntegration: string, skipEmail: boolean) {
    return this.api.post('onboarding/payroll', { preferredPayrollIntegration, skipEmail });
  }
}
